export default "<switch name=\"basicSwitch\" [(ngModel)]=\"value\"></switch>";